/**
 * Qatar Pearl Diving - PDF Presentation Configuration (Arabic)
 *
 * Arabic translation of slide-by-slide configuration with narrations for avatar TTS.
 */

export const qatarPearlDivingPresentation = {
  pdfUrl: 'https://storage.googleapis.com/qudemo-test-qudemo/qatar_pearl.pdf',

  slides: [
    {
      page: 1,
      title: 'تراث صيد اللؤلؤ',
      narration: `تظهر هذه الصورة تراث صيد اللؤلؤ في قطر.   لأجيال عديدة، كان صيد اللؤلؤ شريان حياة اقتصاد قطر.   كان الغواصون يقضون أشهراً في البحر،   يغوصون مراراً لجمع هذه الجواهر الثمينة من الخليج.`,
    },
  ],
};

export default qatarPearlDivingPresentation;
